// extracted by mini-css-extract-plugin
export default {"PageNavigator":"PageNavigator_PageNavigator__cMBwC"};